import React from 'react'

import { reverse } from 'named-urls'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  IconButton,
  Switch,
} from '@material-ui/core'

import { Edit } from '@material-ui/icons'

import { Skeleton } from '@material-ui/lab'

import { routes } from 'routes'
import { Permitted } from 'components/Permissions'
import DialogTax from '../DialogTax'
import DialogTaxInactive from '../DialogTaxInactive'
import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'
import { LogIconButton } from 'components/Logs'

const TaxesTable = ({ data, perPage, onEvent = () => {} }) => {
  const snackbar = useSnackbar()
  const fakeData = Array.from(new Array(perPage))
  const taxes = data ? data : fakeData
  const [dialogTax, setDialogTax] = React.useState(false)
  const [dialogTaxInactive, setDialogTaxInactive] = React.useState(false)
  const [editTax, setEditTax] = React.useState(null)

  const handleClose = () => {
    setDialogTax(false)
    setDialogTaxInactive(false)
    setEditTax(null)
  }

  const setTax = tax => {
    setEditTax(tax)
  }

  const handleChangeStatus = async tax => {
    if (tax.active) {
      setTax(tax)
      setDialogTaxInactive(true)
    } else {
      try {
        await service.recurrence.taxes.update({
          taxId: tax.id,
          tax: { active: true },
        })

        snackbar.open({
          message: 'Imposto ativado com sucesso!',
          variant: 'success',
        })
        onEvent()
      } catch {
        snackbar.open({
          message: 'Falha ao ativar imposto!',
          variant: 'error',
        })
      }
    }
  }

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="20%">Nome</TableCell>
            <TableCell width="15%">Valor</TableCell>
            <TableCell width="20%">Escopo</TableCell>
            <TableCell width="20%">Tipo</TableCell>
            <Permitted someTags={['update_tax', 'destroy_tax']}>
              <TableCell align="right" width="25%"></TableCell>
            </Permitted>
          </TableRow>
        </TableHead>
        <TableBody>
          {taxes.map((tax, index) => {
            if (tax) {
              return (
                <ItemRow
                  key={index}
                  tax={tax}
                  handleOpen={setDialogTax}
                  handleChangeStatus={handleChangeStatus}
                  setTax={setTax}
                />
              )
            }

            return <SkeletonRow key={index} />
          })}
        </TableBody>
      </Table>

      {editTax && (
        <DialogTax
          open={dialogTax}
          handleClose={handleClose}
          tax={editTax}
          onAction={onEvent}
        />
      )}

      {editTax && editTax.id && (
        <DialogTaxInactive
          open={dialogTaxInactive}
          handleClose={handleClose}
          taxId={editTax.id}
          onEvent={onEvent}
        />
      )}
    </>
  )
}

const ItemRow = ({
  tax,
  handleOpen = () => {},
  handleChangeStatus,
  setTax,
}) => {
  return (
    <TableRow hover key={tax.id}>
      <TableCell>{tax.name}</TableCell>
      <TableCell>{`${tax.value}%`}</TableCell>
      <TableCell>{tax.scope}</TableCell>
      <TableCell>{tax.taxType ? tax.taxType.tag : 'Outros'}</TableCell>
      <Permitted someTags={['update_tax', 'destroy_tax']}>
        <TableCell align="right" width="20%">
          <LogIconButton
            to={reverse(routes.settings.taxes.logs, { taxId: tax.id })}
          />

          <Permitted tag="update_tax">
            {tax.active && (
              <Tooltip title="Editar">
                <IconButton
                  aria-label="Editar"
                  onClick={() => {
                    setTax(tax)
                    handleOpen(true)
                  }}
                >
                  <Edit />
                </IconButton>
              </Tooltip>
            )}
          </Permitted>

          <Permitted tag="destroy_tax">
            <Switch
              checked={tax.active}
              onChange={() => handleChangeStatus(tax)}
            />
          </Permitted>
        </TableCell>
      </Permitted>
    </TableRow>
  )
}

const SkeletonRow = () => (
  <TableRow>
    <TableCell>
      <Skeleton variant="rect" width="100%" height={21} />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" height={21} />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width={20} height={21} />
    </TableCell>
  </TableRow>
)

export default TaxesTable
